export class FormSelectOption {
    constructor(value: string, label?: string) {
        this.value = value;
        this.label = label ?? value;
    }

    value: string
    label: string;
}
